<template>
<div class='routeStepper'>
     <router-link class='homeButtonContainer' :to="{path:'/dashboard'}">
    <img   alt="Home"
          class="stepperHomeButton"
          src="../assets/icons/homeStep.png"

    >
    </router-link>
    <span v-for="(step,index) in steps" :key="index" class="stepperItem">
      <router-link  :to="{path:step.path}"><img class="breadcrumb-icon"  src="../assets/icons/breadcrumb.svg" alt="breadcrumb">
      <span class="stepper-text">  {{step.name}}</span>
      </router-link>
    </span>
    </div>
</template>
<script>
export default {
      props:['steps'],
     
      
}
</script>